export const metadataInfo = {
  title: "Best Wireless Microphone for YouTube, Blogging & Video Recording",
  description: "Buy the best wireless microphone for YouTube, blogging, vlogging, video recording, podcasts, and live streaming. Advanced noise cancellation, crystal-clear audio, long battery life, and professional sound quality.",
  keywords: [
    "best wireless microphone", "wireless microphone for youtube", "blogging microphone", "video recording microphone", "wireless mic for content creators", "noise cancellation microphone", "youtube microphone", "vlogging microphone", "podcast microphone", "wireless microphone online", "professional wireless mic", "content creator microphone"
  ],

  alternates: {
    canonical: 'https://ennixelectronics.com',
  },

  openGraph: {
    title: "Best Wireless Microphone for YouTube, Blogging & Video Recording",
    description: "Find the best wireless microphones for vlogging, YouTube videos, reels, podcasts, and professional content creation. Buy microphones and studio equipment online.",
  },

  icons: {
    icon: "/icon-logo.png",
    apple: "/icon-logo.png",
  },
};